module.exports = __webpack_public_path__ + "static/media/img-vuse@2x.14963848.jpg";